import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6 text-blue-600">Privacy Policy</h1>
        
        <div className="prose prose-lg max-w-none">
          <p>Last Updated: April 24, 2025</p>
          
          <p>This Privacy Policy describes how Dental Hero ("we", "our", or "us") collects, uses, and shares your personal information when you visit www.dentalhero.co.uk (the "Website") or use our services.</p>
          
          <h2 className="text-2xl font-bold mt-6 mb-4 text-blue-600">1. Information We Collect</h2>
          
          <h3 className="text-xl font-bold mt-4 mb-2">Personal Information</h3>
          <p>When you use our services, we may collect the following types of personal information:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Contact information (name, email address, phone number, postal address)</li>
            <li>Appointment details and preferences</li>
            <li>Payment information (processed securely through our payment processors)</li>
            <li>Medical and dental history relevant to your treatment</li>
            <li>Communications between you and Dental Hero</li>
          </ul>
          
          <h3 className="text-xl font-bold mt-4 mb-2">Automatically Collected Information</h3>
          <p>When you visit our Website, we automatically collect certain information about your device, including:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>IP address</li>
            <li>Browser type and version</li>
            <li>Operating system</li>
            <li>Time and date of your visit</li>
            <li>Pages you view</li>
            <li>Links you click</li>
            <li>Referring website</li>
          </ul>
          
          <h2 className="text-2xl font-bold mt-6 mb-4 text-blue-600">2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Provide, maintain, and improve our services</li>
            <li>Process and manage your appointments</li>
            <li>Communicate with you about your appointments, our services, and other relevant information</li>
            <li>Process payments</li>
            <li>Connect you with appropriate dental practitioners</li>
            <li>Respond to your inquiries and provide customer support</li>
            <li>Monitor and analyze usage patterns and trends</li>
            <li>Protect against, identify, and prevent fraud and other illegal activities</li>
            <li>Comply with our legal obligations</li>
          </ul>
          
          <h2 className="text-2xl font-bold mt-6 mb-4 text-blue-600">3. Sharing Your Information</h2>
          <p>We may share your personal information with:</p>
          <ul className="list-disc pl-6 mb-4">
            <li><strong>Dental Practitioners:</strong> We share your information with the dental practitioners you are connected with through our service to facilitate your appointment.</li>
            <li><strong>Service Providers:</strong> We use third-party service providers to help us operate our business and the Website or administer activities on our behalf, such as payment processing, email delivery, and hosting services.</li>
            <li><strong>Legal Requirements:</strong> We may disclose your information where we are legally required to do so in order to comply with applicable law, governmental requests, a judicial proceeding, court order, or legal process.</li>
            <li><strong>Business Transfers:</strong> If we are involved in a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred as part of that transaction.</li>
          </ul>
          
          <h2 className="text-2xl font-bold mt-6 mb-4 text-blue-600">4. Cookies and Tracking Technologies</h2>
          <p>We use cookies and similar tracking technologies to track activity on our Website and hold certain information. Cookies are files with a small amount of data which may include an anonymous unique identifier.</p>
          
          <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Website.</p>
          
          <h2 className="text-2xl font-bold mt-6 mb-4 text-blue-600">5. Data Security</h2>
          <p>We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, please also remember that we cannot guarantee that the internet itself is 100% secure.</p>
          
          <h2 className="text-2xl font-bold mt-6 mb-4 text-blue-600">6. Your Data Protection Rights</h2>
          <p>Under the General Data Protection Regulation (GDPR), you have the following rights:</p>
          <ul className="list-disc pl-6 mb-4">
            <li><strong>Right to Access:</strong> You have the right to request copies of your personal data.</li>
            <li><strong>Right to Rectification:</strong> You have the right to request that we correct any information you believe is inaccurate or complete information you believe is incomplete.</li>
            <li><strong>Right to Erasure:</strong> You have the right to request that we erase your personal data, under certain conditions.</li>
            <li><strong>Right to Restrict Processing:</strong> You have the right to request that we restrict the processing of your personal data, under certain conditions.</li>
            <li><strong>Right to Object to Processing:</strong> You have the right to object to our processing of your personal data, under certain conditions.</li>
            <li><strong>Right to Data Portability:</strong> You have the right to request that we transfer the data we have collected to another organization, or directly to you, under certain conditions.</li>
          </ul>
          
          <p>If you would like to exercise any of these rights, please contact us using the contact information provided below.</p>
          
          <h2 className="text-2xl font-bold mt-6 mb-4 text-blue-600">7. Children's Privacy</h2>
          <p>Our Website and services are not intended for children under the age of 16. We do not knowingly collect personal information from children under 16. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we can take necessary actions.</p>
          
          <h2 className="text-2xl font-bold mt-6 mb-4 text-blue-600">8. Changes to This Privacy Policy</h2>
          <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date at the top of this Privacy Policy.</p>
          
          <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
          
          <h2 className="text-2xl font-bold mt-6 mb-4 text-blue-600">9. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>By email: help@dentalhero.co.uk</li>
            <li>By phone: 07383 808 185</li>
            <li>By mail: Suite 1B Statham Link, The Lancastrian Office Centre, Old Trafford, M32 0FP</li>
          </ul>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
